export default __webpack_public_path__ + "static/media/logo.a58f0c50.png";